import type { ReactNode } from 'react';
import Home from './home/Home';
import AllConnectionsList from './connections/AllConnectionsList';
import IdentityProviderList from './identity-providers/IdentityProviderList';

export interface AppRoute {
    path: string;
    label: string;
    exIcon: string;
    element: ReactNode;
}

export const appRoutes: AppRoute[] = [
    {
        path: 'home',
        label: 'Home',
        exIcon: 'Home',
        element: <Home />,
    },
    {
        path: 'connections',
        label: 'Configs',
        exIcon: 'shield',
        element: <AllConnectionsList />,
    },
    {
        path: 'identity-providers',
        label: 'Identity Providers',
        exIcon: 'Identity providers',
        element: <IdentityProviderList />,
    },
];
